import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ImageUrlPipe } from '@libs/shared/utils/pipe/image-url/image-url.pipe';
import { ImageFallbackResizeDirective } from '@libs/shared/utils/directives/image-fallback-resize.directive';

export type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [CommonModule, MatTooltipModule, ImageUrlPipe, ImageFallbackResizeDirective],
  template: `
    <div
      class="relative"
      [ngClass]="{
        'h-6 w-6': avatarSize === 'xs',
        'h-8 w-8': avatarSize === 'sm',
        'h-12 w-12': avatarSize === 'md',
        'h-16 w-16': avatarSize === 'lg',
        'h-24 w-24': avatarSize === 'xl',
      }"
      [matTooltip]="tooltip"
      matTooltipTouchGestures="on">
      <img
        draggable="false"
        appImageFallbackResize
        [ngClass]="{
          'h-6 w-6': avatarSize === 'xs',
          'h-8 w-8': avatarSize === 'sm',
          'h-12 w-12': avatarSize === 'md',
          'h-16 w-16': avatarSize === 'lg',
          'h-24 w-24': avatarSize === 'xl',
          'ring-gray-200': ringType === 'default' && !showMenstruation,
          'ring-primary-500': ringType === 'primary' && !showMenstruation,
          'ring-gray-500': ringType === 'gray' && !showMenstruation,
          'ring-red-500': showMenstruation,
          'object-cover': objectType === 'object-cover',
          'object-contain': objectType === 'object-contain',
        }"
        class="flex-0 ring-bg-card avatar-image rounded-full bg-gray-100 object-cover ring"
        [src]="imageFileKey | imageUrl: imageSize"
        alt="avatar image" />
      @if (showMenstruation) {
        <div
          class="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 transform text-nowrap rounded-full bg-red-500 px-1 py-0.5 text-xs text-white">
          생리
        </div>
      }
    </div>
  `,
  styles: [
    `
      .avatar-image {
        user-drag: none;
        pointer-events: none;
        user-select: none;
        -moz-user-select: none;
        -webkit-user-drag: none;
        -webkit-user-select: none;
        -ms-user-select: none;
      }
    `,
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent {
  @Input() tooltip: string;
  @Input() imageFileKey: string;
  @Input() ringType: 'default' | 'primary' | 'gray' = 'default';
  @Input() ringColor: string;
  @Input() imageSize = '300x300';
  @Input() objectType: 'object-cover' | 'object-contain' = 'object-cover';
  @Input() avatarSize: AvatarSize = 'sm';
  @Input() showMenstruation = false;
}
